<template>
  <div class="d-flex">
    <b-container fluid class="p-0" v-if="rule">
      <b-row no-gutters>
        <!--        <b-col cols="4" class="pr-3">-->
        <!--          <v-select-->
        <!--            :label="$t('attribute')"-->
        <!--            v-model="rule.id"-->
        <!--            :items="options"-->
        <!--            item-text="text"-->
        <!--            item-value="index"-->
        <!--            dense-->
        <!--            outlined-->
        <!--          />-->
        <!--        </b-col>-->
        <b-col cols="6" class="pr-3">
          <v-autocomplete
            v-model="rule.value"
            :label="$t('sku')"
            item-text="systemCode"
            item-value="skuId"
            clearable
            outlined
            dense
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            hide-no-data
            hide-selected
            :error-messages="valueErrors"
            @blur="$v.rule.value.$touch()"
          />
        </b-col>
        <b-col cols="6" class="pr-3">
          <v-text-field
            v-model.number="rule.quantity"
            :label="$t('quantity')"
            type="number"
            :min="0"
            dense
            outlined
            :error-messages="quantityErrors"
            @blur="$v.rule.quantity.$touch()"
            @change="() => validateMinValue('quantity', 0, 'rule')"
          />
        </b-col>
        <!--        <b-col cols="6" class="pr-3" v-if="selectedOption.type == 'dropdown'">-->
        <!--          <v-select-->
        <!--            v-model="rule.value"-->
        <!--            :label="opLabel"-->
        <!--            :items="ruleOperatorOptions"-->
        <!--            item-text="text"-->
        <!--            item-value="index"-->
        <!--            dense-->
        <!--            outlined-->
        <!--            :error-messages="valueErrors"-->
        <!--            @blur="$v.rule.value.$touch()"-->
        <!--          />-->
        <!--        </b-col>-->
        <!--        <b-col cols="6" class="pr-3" v-if="selectedOption.type == 'text'">-->
        <!--          <v-text-field-->
        <!--            v-model="rule.value"-->
        <!--            :label="opLabel"-->
        <!--            dense-->
        <!--            outlined-->
        <!--            :error-messages="valueErrors"-->
        <!--            @blur="$v.rule.value.$touch()"-->
        <!--          />-->
        <!--        </b-col>-->
      </b-row>
    </b-container>
    <div class="max-h-65">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { minValue, required } from "vuelidate/lib/validators";
import { SET_ACTION_NOT_VALID } from "@/core/services/store/omsRules.module";
import { getToken } from "@/core/services/jwt.service";
import fieldValueValidation from "@/own/mixins/fieldValueValidation";

export default {
  name: "Action",
  mixins: [validationMixin, fieldValueValidation],
  validations: {
    rule: {
      value: { required },
      quantity: { required, minValue: minValue(0) },
    },
  },
  props: {
    rule: {
      type: Object,
      required: true,
      default: () => ({
        id: this.options[0].index,
        value: null,
        quantity: null,
      }),
    },
    options: {
      type: Array,
    },
    userId: {
      required: false,
    },
    selectedStatusId: {
      required: false,
      type: Number,
    },
  },
  data: () => ({
    isLoading: false,
    search: null,
    entries: [],
    doneTypingInterval: 1500,
    typingTimer: null,
  }),
  mounted() {
    if (this.rule?.systemCode) {
      this.search = this.rule.systemCode;
    }
  },
  computed: {
    items: function () {
      return this.entries;
    },
    // currentRuleID: function () {
    //   return this.rule.id;
    // },
    // selectedOption() {
    //   return this.options.find((option) => option.index === this.rule.id);
    // },
    // ruleOperatorOptions: function () {
    //   const keyName = this.options.find(
    //     (option) => option.index === this.rule.id
    //   ).key_name;
    //
    //   if (keyName === "status_reason" && this.selectedStatusId) {
    //     return this.operators[`${keyName}`].filter(
    //       (option) => option.status_id === this.selectedStatusId
    //     );
    //   } else {
    //     return this.operators[`${keyName}`];
    //   }
    // },
    // opLabel() {
    //   return this.options.find((option) => option.index === this.rule.id).text;
    // },
    valueErrors: function () {
      return this.handleFormValidation("value", this, "rule");
    },
    quantityErrors: function () {
      return this.handleFormValidation("quantity", this, "rule");
    },
  },
  methods: {
    async getData(value) {
      if (!value) return;
      let data = { q: value };
      if (this.userId) data.client = this.userId;

      await fetch(`${process.env.VUE_APP_BASE_URL}/skus/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => {
          this.entries = res.skus;
        })
        .finally(() => (this.isLoading = false));
    },
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("minValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].minValue &&
          errors.push("This field must be greater than 0");
      }

      return errors;
    },

    deleteRule: function () {
      const self = this;
      const parentRules = self.$parent.currentQuery;
      parentRules.splice(parentRules.indexOf(self.rule), 1);
    },
  },
  watch: {
    search(val) {
      // console.log("val", val);

      this.isLoading = true;
      this.getData(val);
      // clearTimeout(this.typingTimer);
      // if (!val || val === "") {
      //   return;
      // }
      // this.typingTimer = setTimeout(() => {
      //   this.isLoading = true;
      //   this.getData(val.trim());
      // }, this.doneTypingInterval);
    },
    // currentRuleID: function () {
    //   this.rule.value = null;
    // },
    rule: {
      handler() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$store.commit(SET_ACTION_NOT_VALID, true);
        } else {
          this.$store.commit(SET_ACTION_NOT_VALID, false);
        }
      },
      deep: true,
    },
  },
};
</script>
